import type { JSX } from 'react';
import type { ChipVariant } from '@/types';
import Chip from './Chip';

interface SectionHeaderProps {
  chip: string;
  chipVariant: ChipVariant;
  title: string;
  subtitle?: string;
}

function TitleLines({ title }: { title: string }): JSX.Element {
  const lines = title.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="section__title-line">
          {line}
        </span>
      ))}
    </>
  );
}

export default function SectionHeader({ chip, chipVariant, title, subtitle }: SectionHeaderProps): JSX.Element {
  return (
    <div className="section__header">
      <Chip variant={chipVariant}>{chip}</Chip>
      <h2 className="section__title">
        <TitleLines title={title} />
      </h2>
      {subtitle !== undefined && (
        <p className="section__subtitle">{subtitle}</p>
      )}
    </div>
  );
}
